import Hider from "./Hider";
import * as Util from "./Util";

export class SimpleModal {
  private readonly modal: HTMLElement;

  public constructor(element: HTMLElement) {
    this.modal = element;

    const modalId = element.dataset["simpleModalId"];

    if (!modalId) {
      throw new Error("Simple modal created without an attribute data-simple-modal-id to identify it");
    }

    const openElements = SimpleModal.getRelatedElements("simple-modal-open", modalId);
    const closeElements = SimpleModal.getRelatedElements("simple-modal-close", modalId);

    SimpleModal.addDirectClickHandler(openElements, this.openModal.bind(this));
    SimpleModal.addDirectClickHandler(closeElements, this.closeModal.bind(this));
  }

  private static addDirectClickHandler(xs: HTMLElement[], handler: (e: HTMLElement) => void) {
    xs.forEach((x) =>
      x.addEventListener("click", (event) => {
        if (event.target != x) return;
        handler(x);
      })
    );
  }

  private closeModal() {
    Hider.hide(this.modal);
  }

  private openModal() {
    Hider.show(this.modal);
  }

  private static getRelatedElements(bindName: string, modalId: string): HTMLElement[] {
    return Array.from(Util.findByBindNameAll(bindName))
      .map((node) => node as HTMLElement)
      .filter((node) => node.dataset["simpleModalId"] == modalId);
  }
}

export default function bindModals(): void {
  const modals = Util.findByBindNameAll("simple-modal");
  modals.forEach((s) => new SimpleModal(s as HTMLElement));
}
